import { render, staticRenderFns } from "./ReadOnlyElement.vue?vue&type=template&id=38c5bc16&scoped=true&"
import script from "./ReadOnlyElement.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyElement.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyElement.vue?vue&type=style&index=0&id=38c5bc16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c5bc16",
  null
  
)

export default component.exports